// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_bm-2";
export var aiChatCartContainerExit = "_bm-4";
export var aiChatContainerLarge = "_bm-0";
export var aiChatContainerSmall = "_bm-1";
export var aiChatIcon = "_bm-6";
export var slideInFromRight = "_bm-3";
export var slideOutToRight = "_bm-5";